(function ($) {
    var CLOSE_DELAY_MS = 120;
    var DESKTOP_BREAKPOINT = 1200;

    function isDesktopMega() {
        return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
    }

    function setMegaOpen($item, open) {
        var $trigger = $item.children('a.mega-menu-trigger');
        var $panel = $item.children('.header-menu-dropdown');

        $item.toggleClass('is-mega-open', open);
        $panel.toggleClass('is-open', open);
        $trigger.attr('aria-expanded', open ? 'true' : 'false');
    }

    function closeAllMega($except) {
        $('.menu-item-has-mega').each(function () {
            if ($except && this === $except[0]) {
                return;
            }
            setMegaOpen($(this), false);
        });
    }

    function initDesktopMegaDropdowns() {
        $('.menu-top .menu-item-has-mega').each(function () {
            var $item = $(this);
            var $panel = $item.children('.header-menu-dropdown');
            var closeTimer = null;

            if (!$panel.length) {
                return;
            }

            $item.on('mouseenter', function () {
                if (!isDesktopMega()) {
                    return;
                }
                clearTimeout(closeTimer);
                closeAllMega($item);
                setMegaOpen($item, true);
            });

            $item.on('mouseleave', function () {
                if (!isDesktopMega()) {
                    return;
                }
                clearTimeout(closeTimer);
                closeTimer = setTimeout(function () {
                    setMegaOpen($item, false);
                }, CLOSE_DELAY_MS);
            });

            $panel.on('mouseenter', function () {
                if (!isDesktopMega()) {
                    return;
                }
                clearTimeout(closeTimer);
            });

            $panel.on('mouseleave', function () {
                if (!isDesktopMega()) {
                    return;
                }
                clearTimeout(closeTimer);
                closeTimer = setTimeout(function () {
                    setMegaOpen($item, false);
                }, CLOSE_DELAY_MS);
            });

            $item.children('a.mega-menu-trigger').on('click', function (event) {
                if (!isDesktopMega()) {
                    return;
                }
                event.preventDefault();
            });
        });

        $(window).on('resize', function () {
            if (!isDesktopMega()) {
                closeAllMega();
            }
        });
    }

    function initMobileMegaDropdowns() {
        $('.mobile--inner--wrapper .menu-item-has-mega').each(function () {
            $(this).addClass('acc-submenu');
        });

        $('.mobile--inner--wrapper .menu-item-has-mega > a.mega-menu-trigger').on('click', function (event) {
            if (isDesktopMega()) {
                return;
            }

            event.preventDefault();
            event.stopPropagation();

            var $trigger = $(this);
            var $item = $trigger.parent();
            var $panel = $item.children('.header-menu-dropdown');
            var willOpen = !$panel.hasClass('acc--menu--open');

            $('.mobile--inner--wrapper .menu-item-has-mega').not($item).each(function () {
                var $other = $(this);
                $other.children('a.mega-menu-trigger').removeClass('rotate');
                $other.children('.header-menu-dropdown').removeClass('acc--menu--open').slideUp('slow');
            });

            if (willOpen) {
                $trigger.addClass('rotate');
                $panel.addClass('acc--menu--open').slideDown('slow', function () {
                    $(this).css('overflow', 'visible');
                });
            } else {
                $trigger.removeClass('rotate');
                $panel.removeClass('acc--menu--open').slideUp('slow');
            }
        });
    }

    $(document).ready(function () {
        initDesktopMegaDropdowns();
        initMobileMegaDropdowns();
    });
})(jQuery);
